export default "__VITE_ASSET__DpmicMS3__"